(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('CustomerCharges', CustomerCharges);

    CustomerCharges.$inject = ['$resource'];

    function CustomerCharges ($resource) {
        var resourceUrl =  'api/customer-charges/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/customer-charges'
        	 },
         	
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
            	
             'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/customer-charges/orgId/:orgId',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
        	
             'update': {
             	method:'PUT',
             	params: {orgId:'@orgId'},
                url: 'api/customer-charges/orgId/:orgId',
             	transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/customer-charges',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
              
        });
    }
})();
